import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";

@Component({
  selector: "field-set-add-another-position",
  templateUrl: "./field-set-add-another-position.component.html",
  styles: [],
})
export class FieldSetAddAnotherPositionComponent {
  @Input() public fieldOptions: any = {};
  @Output() public dataChanged = new EventEmitter();

  public dataChangedEvent(event) {
    this.dataChanged.emit(event);
  }
}
